// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/route_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Route, RouteStatus } from "./route_pb.js";
import { file_transportation_v1_route } from "./route_pb.js";
import type { RouteAssignedEvent, RouteCancelledEvent, RouteCompletedEvent, RouteFailedEvent, RouteStartedEvent, RouteTaskAddedEvent, RouteTaskRemovedEvent, RouteUnassignedEvent } from "./route_custom_events_pb.js";
import { file_transportation_v1_route_custom_events } from "./route_custom_events_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/route_events.proto.
 */
export const file_transportation_v1_route_events: GenFile = /*@__PURE__*/
  fileDesc("CiR0cmFuc3BvcnRhdGlvbi92MS9yb3V0ZV9ldmVudHMucHJvdG8SEXRyYW5zcG9ydGF0aW9uLnYxIuoFCgpSb3V0ZUV2ZW50EjcKB2NyZWF0ZWQYASABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZUNyZWF0ZWRFdmVudEgAEjcKB3VwZGF0ZWQYAiABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZVVwZGF0ZWRFdmVudEgAEjcKB2RlbGV0ZWQYAyABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZURlbGV0ZWRFdmVudEgAEkQKDnN0YXR1c19jaGFuZ2VkGAQgASgLMioudHJhbnNwb3J0YXRpb24udjEuUm91dGVTdGF0dXNDaGFuZ2VkRXZlbnRIABI3CgdzdGFydGVkGAUgASgLMiQudHJhbnNwb3J0YXRpb24udjEuUm91dGVTdGFydGVkRXZlbnRIABI7Cgljb21wbGV0ZWQYBiABKAsyJi50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZUNvbXBsZXRlZEV2ZW50SAASOwoJY2FuY2VsbGVkGAcgASgLMiYudHJhbnNwb3J0YXRpb24udjEuUm91dGVDYW5jZWxsZWRFdmVudEgAEjUKBmZhaWxlZBgIIAEoCzIjLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlRmFpbGVkRXZlbnRIABI5Cghhc3NpZ25lZBgJIAEoCzIlLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlQXNzaWduZWRFdmVudEgAEj0KCnVuYXNzaWduZWQYCiABKAsyJy50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZVVuYXNzaWduZWRFdmVudEgAEjwKCnRhc2tfYWRkZWQYCyABKAsyJi50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZVRhc2tBZGRlZEV2ZW50SAASQAoMdGFza19yZW1vdmVkGAwgASgLMigudHJhbnNwb3J0YXRpb24udjEuUm91dGVUYXNrUmVtb3ZlZEV2ZW50SABCBwoFZXZlbnQiPAoRUm91dGVDcmVhdGVkRXZlbnQSJwoFcm91dGUYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZSJ2ChFSb3V0ZVVwZGF0ZWRFdmVudBIwCg5wcmV2aW91c19yb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlEi8KDXVwZGF0ZWRfcm91dGUYAiABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZSI8ChFSb3V0ZURlbGV0ZWRFdmVudBInCgVyb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlIq8BChdSb3V0ZVN0YXR1c0NoYW5nZWRFdmVudBInCgVyb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlEjcKD3ByZXZpb3VzX3N0YXR1cxgCIAEoDjIeLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlU3RhdHVzEjIKCm5ld19zdGF0dXMYAyABKA4yHi50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZVN0YXR1c0JBWj9wYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS10cmFuc3BvcnRhdGlvbi9hcGkvdjE7dHJhbnNwb3J0YXRpb25fdjFiCGVkaXRpb25zcOgH", [file_transportation_v1_route, file_transportation_v1_route_custom_events]);

/**
 * @generated from message transportation.v1.RouteEvent
 */
export type RouteEvent = Message<"transportation.v1.RouteEvent"> & {
  /**
   * @generated from oneof transportation.v1.RouteEvent.event
   */
  event: {
    /**
     * @generated from field: transportation.v1.RouteCreatedEvent created = 1;
     */
    value: RouteCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: transportation.v1.RouteUpdatedEvent updated = 2;
     */
    value: RouteUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: transportation.v1.RouteDeletedEvent deleted = 3;
     */
    value: RouteDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: transportation.v1.RouteStatusChangedEvent status_changed = 4;
     */
    value: RouteStatusChangedEvent;
    case: "statusChanged";
  } | {
    /**
     * @generated from field: transportation.v1.RouteStartedEvent started = 5;
     */
    value: RouteStartedEvent;
    case: "started";
  } | {
    /**
     * @generated from field: transportation.v1.RouteCompletedEvent completed = 6;
     */
    value: RouteCompletedEvent;
    case: "completed";
  } | {
    /**
     * @generated from field: transportation.v1.RouteCancelledEvent cancelled = 7;
     */
    value: RouteCancelledEvent;
    case: "cancelled";
  } | {
    /**
     * @generated from field: transportation.v1.RouteFailedEvent failed = 8;
     */
    value: RouteFailedEvent;
    case: "failed";
  } | {
    /**
     * @generated from field: transportation.v1.RouteAssignedEvent assigned = 9;
     */
    value: RouteAssignedEvent;
    case: "assigned";
  } | {
    /**
     * @generated from field: transportation.v1.RouteUnassignedEvent unassigned = 10;
     */
    value: RouteUnassignedEvent;
    case: "unassigned";
  } | {
    /**
     * @generated from field: transportation.v1.RouteTaskAddedEvent task_added = 11;
     */
    value: RouteTaskAddedEvent;
    case: "taskAdded";
  } | {
    /**
     * @generated from field: transportation.v1.RouteTaskRemovedEvent task_removed = 12;
     */
    value: RouteTaskRemovedEvent;
    case: "taskRemoved";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message transportation.v1.RouteEvent.
 * Use `create(RouteEventSchema)` to create a new message.
 */
export const RouteEventSchema: GenMessage<RouteEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_events, 0);

/**
 * @generated from message transportation.v1.RouteCreatedEvent
 */
export type RouteCreatedEvent = Message<"transportation.v1.RouteCreatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;
};

/**
 * Describes the message transportation.v1.RouteCreatedEvent.
 * Use `create(RouteCreatedEventSchema)` to create a new message.
 */
export const RouteCreatedEventSchema: GenMessage<RouteCreatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_events, 1);

/**
 * @generated from message transportation.v1.RouteUpdatedEvent
 */
export type RouteUpdatedEvent = Message<"transportation.v1.RouteUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route previous_route = 1;
   */
  previousRoute?: Route;

  /**
   * @generated from field: transportation.v1.Route updated_route = 2;
   */
  updatedRoute?: Route;
};

/**
 * Describes the message transportation.v1.RouteUpdatedEvent.
 * Use `create(RouteUpdatedEventSchema)` to create a new message.
 */
export const RouteUpdatedEventSchema: GenMessage<RouteUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_events, 2);

/**
 * @generated from message transportation.v1.RouteDeletedEvent
 */
export type RouteDeletedEvent = Message<"transportation.v1.RouteDeletedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;
};

/**
 * Describes the message transportation.v1.RouteDeletedEvent.
 * Use `create(RouteDeletedEventSchema)` to create a new message.
 */
export const RouteDeletedEventSchema: GenMessage<RouteDeletedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_events, 3);

/**
 * @generated from message transportation.v1.RouteStatusChangedEvent
 */
export type RouteStatusChangedEvent = Message<"transportation.v1.RouteStatusChangedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: transportation.v1.RouteStatus previous_status = 2;
   */
  previousStatus: RouteStatus;

  /**
   * @generated from field: transportation.v1.RouteStatus new_status = 3;
   */
  newStatus: RouteStatus;
};

/**
 * Describes the message transportation.v1.RouteStatusChangedEvent.
 * Use `create(RouteStatusChangedEventSchema)` to create a new message.
 */
export const RouteStatusChangedEventSchema: GenMessage<RouteStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_events, 4);

